export function checkEmpty(value) {
  return value === '' || value === null ? undefined : value;
}
